const mapStateToProps = (state) => {
    const {
        ui:{
            selectedGeoObjArray,
        }={},
    } = state;
    return { selectedGeoObjArray }
}

export default mapStateToProps;